import React, { FC } from "react";
import { v4 as uuidv4 } from "uuid";

import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

import { makeStyles, Theme } from "@material-ui/core/styles";

interface ListProps {
  title: React.ReactNode;
  items: React.ReactNode[];
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    title: {
      color: theme.palette.primary.main,
    },
    list: {
      padding: 0,
    },
  };
});

const List: FC<ListProps> = ({ title, items }) => {
  const classes = useStyles();

  return (
    <ul className={classes.list}>
      <Typography variant="body1" className={classes.title}>
        {title}
      </Typography>
      <Box ml={3}>
        {items &&
          items.map((item) => (
            <li key={uuidv4()}>
              <Typography variant="body1">{item}</Typography>
            </li>
          ))}
      </Box>
    </ul>
  );
};

export default List;
